import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import info from './info'
import category from './category'
import record from './record'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  	error:null 
    //делаем шину ошибок 8/13,33
  },
  mutations: {
  	setError(state,error){
         
  		state.error = error
    //мутатион по именению сейта ошибок
    //делаем мутацию меняем стейт еррор на значение еррор
  	},
  	clearError(state){
  		state.error = null
//принимает стейт. обращается к полю стейт еррор и обнуляет

  	}
  },
  //получение доступа до данной ошибки с помошью поля геттерс
  actions: {
    async fetchCurrency() {
      const key = process.env.VUE_APP_FIXER
      // const res = await fetch(`http://data.fixer.io/api/latest?access_key=${key}&symbols=USD,EUR,RUB`)
       const res = await fetch(`https://api.exchangerate-api.com/v4/latest/EUR`)

     
     // debugger
      return await res.json()
    }
  },
  getters:{
  	error: s=>s.error
    //реализум геттер еррор. принимает некоторый стейт который возвращает стейт еррор
    
  },
   
  modules: {
  	auth, info, category, record //добавляем инфо в список модулей
  }
})
